import axiosClient from './axiosClient';

const rideTripApi = {
  getTrips: (params) => axiosClient.get('/rides/trips', { params }),
  getTrip: (tripId) => axiosClient.get(`/rides/trips/${tripId}`),
  cancelTrip: (tripId, reason) => axiosClient.post(`/rides/trips/${tripId}/cancel`, { reason }),
};

export default rideTripApi;
